import { globalStyle, style } from "@vanilla-extract/css";
import { vars } from "./theme.css";

/**
 * Opt-in typography scope. Apply to any container whose raw markup
 * (p, ul, ol, li) should receive prose-level spacing and list styles.
 * Keeps the rest of the UI on a clean slate.
 * https://css-tricks.com/opt-in-typography/
 */
export const copy = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.m,
});

globalStyle(`${copy} p`, {
  lineHeight: 1.6,
});

globalStyle(`${copy} ul, ${copy} ol`, {
  display: "flex",
  flexDirection: "column",
  gap: vars.space.xs,
  paddingInlineStart: vars.space.l,
});

globalStyle(`${copy} ul li`, {
  listStyleType: "disc",
});

globalStyle(`${copy} ol li`, {
  listStyleType: "decimal",
});
